<template>
  <div id="app" data-server-rendered="true">
    <yp-navbar ref="navbar" class="no-transparent-navbar"></yp-navbar>
    <page-title-bg first-font="p" title-en="RODUCT CENTER" title-zh="产品中心"></page-title-bg>
    <div class="bread-crumbs-container">
      <div class="container">
        <ol class="breadcrumb">
          <li><a href="/index.html">首页</a></li>
          <li><a href="/product.html">产品中心</a></li>
          <li class="active">合作案例</li>
        </ol>
      </div>
    </div>
    <section class="enterprise-profile-container">
      <div class="container">
        <div class="sec-title-container">
          <div class="sec-title-zh">合作案例</div>
          <div class="sec-title-en">COOPERATION CASE</div>
        </div>
        <div class="case-center">
          <div class="case-center-column">
            <div class="case-center-img">
              <img src="/static/images/humen.png" alt="" />
            </div>
            <div class="case-center-box shopping-right">
              <div class="case-center-box-title">购物中心典型客户---虎门国际购物中心</div>
              <div class="case-center-box-text">
                虎门国际购物中心是集购物、商务、餐饮、休闲、娱乐等全方位、多功能的国际化购物中心。项目配备4大街区广场，总合计建筑面积约17万平方米，地上1-4层以及地下一层为大型商业购物中心，地下负二层为停车场，首创下沉式商业广场，同时建设有东莞最大的IMAX影屏。
              </div>
            </div>
          </div>
          <div class="case-center-column case-center-reverse">
            <div class="case-center-box">
              <div class="case-center-box-title">购物中心典型客户---深圳金光华</div>
              <div class="case-center-box-text">
                金光华广场是深圳第一家与地铁无缝连接的国际购物广场，项目占地1.8万平方米，建筑面积12万平方米，楼高45米，由地下3层与地上8层的主体建筑及一个8500多平方米的前广场组成。是一家与国际高级商业中心接轨的大型现代Shoping
                Mall。
              </div>
            </div>
            <div class="case-center-img">
              <img src="/static/images/szjgh.png" alt="" />
            </div>
          </div>
          <div class="case-center-column">
            <div class="case-center-img">
              <img src="/static/images/jlc.png" alt="" />
            </div>
            <div class="case-center-box shopping-right">
              <div class="case-center-box-title">购物中心典型客户---威海九龙城</div>
              <div class="case-center-box-text">
                威海九龙城休闲购物广场整体占地5万平方米，总建筑面积23.87万平方米，是由写字楼、商业及酒店式公寓围合而成高度近百米的建筑群，将集合居住、办公、购物、餐饮、娱乐、休闲、运动等多种功能于一体的大型城市综合体。
              </div>
            </div>
          </div>
          <div class="case-center-column case-center-reverse">
            <div class="case-center-box">
              <div class="case-center-box-title">购物中心典型客户---花样年</div>
              <div class="case-center-box-text">
                购物中心控股集团有限公司起步于1998年，总部设立于深圳，2009年11月，购物中心控股在香港联交所主板成功上市，股份代号为HK177。购物中心在以房地产为支撑的前提下，大举进军商业地产领域，购物中心商业总体战略目标是运营13个项目，总运营面积150万平方米。
              </div>
            </div>
            <div class="case-center-img">
              <img src="/static/images/hyn.png" alt="" />
            </div>
          </div>
        </div>
        <member-enterprises></member-enterprises>
      </div>
    </section>
    <yp-footer></yp-footer>
  </div>
</template>
<script>
import YpNavbar from '@/components/navbar.vue'
import PageTitleBg from '@/components/page-title-bg.vue'
import MemberEnterprises from './components/member-enterprises.vue'
import YpFooter from '@/components/footer.vue'
export default {
  components: {
    YpNavbar,
    PageTitleBg,
    MemberEnterprises,
    YpFooter,
  },
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
